export let calendarMonth_August = "SUyEo";
export default {calendarMonth_August};